<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/setup/usage-rating/uom" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.EditUOM") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Name')"
              >
                <vs-input
                  v-model="Name"
                  :label="$t('setup.label.Name')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Description')"
              >
                <vs-input
                  v-model="Description"
                  :label="$t('setup.label.Description')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createsystem"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";

export default {
  data() {
    return {
      Name: "",
      Description: "",
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      systemById: {},
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },

  computed: {
    ...mapState({
      uomId: (state) => state.usageRating.uomId,
    }),
  },
  methods: {
    async getTemplateData() {},
    async editsystemDataById() {
      try {
        await this.$store.dispatch(
          "usageRating/fetchUomById",
          this.$route.params.id
        );
        this.systemById = this.uomId;
        this.Name = this.systemById.Name;
        this.Description = this.systemById.Description;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createsystem() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        Name: this.Name,
        Description: this.Description,
      };
      try{
      await this.$store.dispatch("usageRating/updateUomAction", {
        id: this.$route.params.id,
        data: payload,
      });
      this.$swal({
        title: "Success",
        icon: "success",
        text: "UOM Edited Successfully!",
        type: "success",
      });
      this.$router.push("/setup/usage-rating/uom");
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    cancel() {
      this.$router.push("/setup/usage-rating/uom");
    },
  },

  mounted() {
    this.getTemplateData();
    this.editsystemDataById();
  },
};
</script>
